import { Module } from 'vuex'
import actions from './companyActions'
import mutations from './companyMutations'
import getters from '@/modules/common/store/entityGetters'
import RootState from '@/store/rootState'
import CompanyState from '@/modules/company/store/companyState'

const companyModule: Module<CompanyState, RootState> = {
  namespaced: true,
  state: new CompanyState(),
  mutations,
  getters,
  actions
}

export default companyModule
